import _ from "lodash";

// Given a list of GlossaryTerms, construct a RegExp to find them in text.
// We handle simple plurals (term + "s") but otherwise expect the term to be surrounded by non-whitespace.

const sortLongestFirst = (terms: readonly string[]) => _.reverse(_.sortBy(terms, "length"));

export default (terms: readonly string[]) =>
  new RegExp(`\\b(${_.map(sortLongestFirst(terms), _.escapeRegExp).join("|")})\\b`, "gi");
